export enum RequestCorrespondenceSource {
	SbaOversight = "SBA_OVERSIGHT",
	FollowUp = "FOLLOW_UP",
	Investigation = "INVESTIGATION",
	Prosecution = "PROSECUTION",
	Discipline = "DISCIPLINE",
	Party = "PARTY",
}
